// Navigation model for the app shell. One list, used by the desktop header,
// the phone tab bar, the phone More sheet and the user menu.

/** Desktop header links, in the mockups' order. `tour` = data-tour anchor (Tour.jsx). */
export const MAIN_NAV = [
  { key: 'portfolio', label: 'Portfolio', to: '/profile/portfolio', tour: 'nav-portfolio' },
  { key: 'autotrader', label: 'AutoTrader', to: '/profile/traderform', tour: 'nav-autotrader' },
  { key: 'scanners', label: 'Scanners', to: '/profile/scanners', tour: 'nav-scanners' },
  { key: 'watchlist', label: 'Watchlist', to: '/profile/watchlist', tour: 'nav-watchlist' },
  { key: 'data', label: 'Data', to: '/profile/data', tour: 'nav-data' },
  { key: 'research', label: 'Research', to: '/profile/research', tour: 'nav-research' },
];

/** Phone bottom tab bar (phone_lib.js): four sections + More. */
export const TAB_BAR = [
  { key: 'portfolio', label: 'Portfolio', to: '/profile/portfolio', icon: 'portfolio', tour: 'nav-portfolio' },
  { key: 'autotrader', label: 'AutoTrader', to: '/profile/traderform', icon: 'autotrader', tour: 'nav-autotrader' },
  { key: 'scanners', label: 'Scanners', to: '/profile/scanners', icon: 'scanners', tour: 'nav-scanners' },
  { key: 'research', label: 'Research', to: '/profile/research', icon: 'research', tour: 'nav-research' },
  { key: 'more', label: 'More', icon: 'more' },
];

/**
 * Gap element (DECISIONS Rule 0 / A1): everything with no drawn place.
 * Desktop user menu = ACCOUNT_MENU; phone More sheet = MORE_SHEET (adds the
 * two sections the tab bar has no room for).
 */
export const ACCOUNT_MENU = [
  { key: 'settings', label: 'Settings', to: '/profile/settings', icon: 'settings' },
  { key: 'billing', label: 'Billing', to: '/profile/subscription', icon: 'billing' },
  { key: 'about', label: 'About', to: '/profile/about', icon: 'about' },
  { key: 'terms', label: 'Terms', to: '/profile/terms', icon: 'terms' },
  { key: 'privacy', label: 'Privacy', to: '/profile/privacy', icon: 'privacy' },
];

export const MORE_SHEET = [
  { key: 'watchlist', label: 'Watchlist', to: '/profile/watchlist', icon: 'watchlist', tour: 'nav-watchlist' },
  { key: 'data', label: 'Data', to: '/profile/data', icon: 'data', tour: 'nav-data' },
  ...ACCOUNT_MENU,
];

const starts = (path, prefix) => path === prefix || path.startsWith(`${prefix}/`);

/** Which main section a pathname belongs to ('portfolio' … 'research', or null). */
export function activeSection(pathname = '') {
  const p = pathname.replace(/^\/profile\/legacy/, '/profile');
  const hit = MAIN_NAV.find((n) => starts(p, n.to));
  return hit ? hit.key : null;
}

/** "Settings" stays highlighted on Billing and the old /profile/account path (Toolbar.js rule). */
export const isSettingsPath = (pathname = '') =>
  starts(pathname, '/profile/settings') || starts(pathname, '/profile/subscription') || starts(pathname, '/profile/account');

/** The phone tab that is active for a pathname: a section key, or 'more'. */
export function activeTab(pathname = '') {
  const s = activeSection(pathname);
  if (s && TAB_BAR.some((t) => t.key === s)) return s;
  return 'more';
}

/** Default phone header title for pages that do not set one. */
export function defaultPhoneTitle(pathname = '') {
  const s = activeSection(pathname);
  if (s) return MAIN_NAV.find((n) => n.key === s).label;
  const acct = ACCOUNT_MENU.find((m) => starts(pathname, m.to));
  if (acct) return acct.label;
  if (isSettingsPath(pathname)) return 'Settings';
  if (starts(pathname, '/profile/ui-kit')) return 'UI kit';
  return 'Cryptologics';
}
